import React from 'react';
import { withAppContext } from '@ctsu/loader';
import { compose } from 'recompose';
import molecules from 'ctsutheme/components/molecules';
import atoms from 'ctsutheme/components/atoms';
import { NoDataFound } from 'components';
import { TE } from 'appconstants';
import { ViewFundingDetails } from './ViewFundingDetails';

const { List, ListSubHeader } = molecules;
const { Typography } = atoms;

export const fundingDetails = ({
  data,
  fundingIndex
}) => (
  <List
    subheader={(
      <ListSubHeader flex>
        <Typography data-id={`${TE.ID}funding_additional_details${TE.LBL}`} inline primary>
            Additional Details
        </Typography>
      </ListSubHeader>
    )}
  >
    {(data && data[fundingIndex])
      ? <ViewFundingDetails fundingInfo={data[fundingIndex]} /> : <NoDataFound />}
  </List>
);

export const FundingDetails = compose(
  withAppContext
)(fundingDetails);
